var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import MeetingTypeService from "../../services/MeetingTypeService";
export default class MeetingTypeConfiguration extends PureComponent {
    static getTimeString(numberMinutes) {
        const hours = Math.floor(numberMinutes / 60);
        const minutes = numberMinutes % 60;
        let timeString = "";
        if (hours) {
            timeString = `${hours} ${hours > 1 ? "hours" : "hour"}`;
            if (minutes) {
                timeString += `, ${minutes} ${minutes > 1 ? "minutes" : "minute"}`;
            }
        }
        else {
            timeString = `${minutes} minutes`;
        }
        return timeString;
    }
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // @ts-expect-error - TS2416 - Property 'state' in type 'MeetingTypeConfiguration' is not assignable to the same property in base type 'PureComponent<Record<any, any>, State, any>'.
        this.state = {
            meetingTypes: [],
            deletingMeetingType: null,
            deleteErrors: [],
            deleteSuccess: false,
        };
        this.loadMeetingTypes();
        this.renderMeetingType = this.renderMeetingType.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.closeDeleteConfirmModal = this.closeDeleteConfirmModal.bind(this);
        this.delete = this.delete.bind(this);
    }
    loadMeetingTypes() {
        return __awaiter(this, void 0, void 0, function* () {
            const meetingTypes = yield MeetingTypeService.fetchMeetingTypes();
            this.setState({ meetingTypes });
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'meetingType' implicitly has an 'any' type.
    onDeleteClick(meetingType) {
        this.setState({
            // @ts-expect-error - TS2345 - Argument of type '{ showDeleteConfirm: boolean; deleteSuccess: false; deletingMeetingType: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Record<any, any>>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            showDeleteConfirm: true,
            deleteSuccess: false,
            deletingMeetingType: meetingType,
        });
    }
    closeDeleteConfirmModal() {
        this.setState({
            showDeleteConfirm: false,
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'MeetingType'.
            deletingMeetingType: null,
        });
    }
    delete() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield MeetingTypeService.deleteMeetingType(
                // @ts-expect-error - TS2531 - Object is possibly 'null'.
                this.state.deletingMeetingType.id);
                if (response.success) {
                    this.setState({
                        deleteSuccess: true,
                        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'MeetingType'.
                        deletingMeetingType: null,
                    });
                    this.loadMeetingTypes();
                }
                else {
                    this.onDeleteError(`Error deleting meeting: ${response.message}`);
                }
            }
            catch (err) {
                this.onDeleteError(`Error deleting meeting: ${err}`);
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
    onDeleteError(error) {
        this.setState({ deleteErrors: [...this.state.deleteErrors, error] });
    }
    renderMeetingType(meetingType) {
        return (_jsx("div", { className: "card mb-3", children: _jsxs("div", { className: "card-body", children: [_jsx("div", { children: _jsx("h4", { children: meetingType.name }) }), _jsxs("div", { className: "mb-3", children: [meetingType.active ? (_jsxs("span", { className: "badge badge-success mr-1", children: [_jsx("span", { className: "fas fa-check", "aria-hidden": "true" }), " Active"] })) : (_jsxs("span", { className: "badge badge-danger mr-1", children: [_jsx("span", { className: "fas fa-times", "aria-hidden": "true" }), " Inactive"] })), meetingType.requiresLocation && (_jsx("span", { "ng-if": "meetingType.requiresLocation", children: _jsxs("span", { className: "badge badge-info mr-1", children: [_jsx("span", { className: "fa fa-location-arrow", "aria-hidden": "true" }), " ", "Requires Location"] }) })), _jsxs("span", { className: "badge badge-dark", children: [_jsx("span", { className: "far fa-clock", "aria-hidden": "true" }), " ", MeetingTypeConfiguration.getTimeString(meetingType.durationMinutes)] })] }), meetingType.additionalInfo && (_jsxs("div", { children: [_jsx("strong", { children: "Additional Info: " }), _jsx("span", { className: "text-muted", children: meetingType.additionalInfo })] })), _jsxs("div", { className: "text-muted mt-3", children: [new Date(meetingType.createdDate).toLocaleDateString(), "\u00A0by ", meetingType.createdBy.firstName, " ", meetingType.createdBy.lastName, " -\u00A0", new Date(meetingType.modifiedDate).toLocaleDateString(), "\u00A0by ", meetingType.modifiedBy.firstName, " ", meetingType.modifiedBy.lastName] })] }) }, meetingType.id));
    }
    renderNoTypesMessage() {
        return (_jsx("div", { className: "card", children: _jsx("div", { className: "card-body", children: "You currently have no meeting types." }) }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx("content", { tag: "secondaryNavbar", children: _jsx("div", { className: "navbar-secondarynav fixed fit-to-parent border-right", role: "navigation", style: { width: "100%" } }) }), _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsx("h1", { className: "title", children: "Meeting Types" }) }) }), this.state.meetingTypes.length
                            ? this.state.meetingTypes.map(this.renderMeetingType)
                            : this.renderNoTypesMessage()] })] }));
    }
}
